<script lang="ts" setup>
const props = defineProps<{
  vertical?: boolean
  align?: string
  gap?: string
  padding?: string
  wrap?: boolean
}>()

const _gap = props.gap ?? '12px'
</script>

<template>
  <div
    class="i-space"
    :class="vertical ? 'vertical' : 'horizontal'"
    :style="{
      flexDirection: vertical ? 'column' : 'row',
      gap: _gap,
      alignItems: align,
      padding,
      flexWrap: wrap ? 'wrap' : 'nowrap'
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" scoped>
// flex gap support chrome 82+
// i tried to make it work in lower version but failed
// here is the solution

// @mixin gapBottom($size) {
//   margin-bottom: calc(0px - $size);

//   & > :deep(*) {
//     margin-bottom: $size;
//   }
// }

// @mixin gapRight($size) {
//   margin-right: calc(0px - $size);

//   & > :deep(*) {
//     margin-right: $size;
//   }
// }

.i-space {
  display: flex;
}

// .i-space.vertical {
//   @include gapBottom(v-bind(_gap));
// }

// .i-space.horizontal {
//   @include gapRight(v-bind(_gap));
// }
</style>
